// import en_GB from './en_GB';
import zh from './zh';
/**
 * 默认导出所有语言集
 */
const i18nLanguages = [
    { "label": "简体中文", "name": "简体中文", "local": "zh" ,antLocal:"zh_CN"},
    { "label": "繁体中文", "name": "繁体中文", "local": "zh-TW",antLocal:"zh_TW" },
    { "label": "英文", "name": "English", "local": "en" ,antLocal:"en_US"},
    { "label": "西班牙语", "name": "Español", "local": "es" ,antLocal:"es_ES"  },
    { "label": "韩语", "name": "한국어", "local": "ko" ,antLocal:"ko_KR"  },
    { "label": "日语", "name": "日本語", "local": "ja",antLocal:"ja_JP"  },
    { "label": '俄语', "name": "Русский", "local": "ru" ,antLocal:"ru_RU"  },
    { "label": "越南语", "name": "Tiếng Việt", "local": "vi" ,antLocal:"vi_VN"  },
    { "label": "法语", "name": "Français", "local": "fr" ,antLocal:"fr_FR"  },
    { "label": "德语", "name": "Deutsch", "local": "de" ,antLocal:"de_DE"  },
    { "label": "意大利语", "name": "Italiano", "local": "it" ,antLocal:"it_IT"},
    { "label": "荷兰语", "name": "Nederlands", "local": "nl" ,antLocal:"nl_NL"  },
    { "label": "阿拉伯语", "name": "العربية", "local": "ar" ,antLocal:"ar_EG"  },
    { "label": "印尼语", "name": "Bahasa Indonesia", "local": "id" ,antLocal:"id_ID"  },
    { "label": "哈萨克语", "name": "Қазақ тілі", "local": "kk",},
    { "label": "波兰语", "name": "Polski", "local": "pl" ,antLocal:"pl_PL"  },
    { "label": "葡萄牙语", "name": "Português", "local": "pt" ,antLocal:"pt_BR"  },
    { "label": "泰语", "name": "ภาษาไทย", "local": "th" ,antLocal:"th_TH"  },
    { "label": "乌克兰语", "name": "Українська", "local": "uk" ,antLocal:"uk_UA"  },
    { "label": "希腊语", "name": "Ελληνικά", "local": "el" ,antLocal:"el_GR"  },
    { "label": "土耳其语", "name": "Türkçe", "local": "tr" ,antLocal:"tr_TR"  },
    { "label": "印地语", "name": "हिंदी", "local": "hi" ,antLocal:"hi_IN"  },
    { "label": "阿尔巴尼亚语", "name": "Gjuha shqipe", "local": "sq" },
    { "label": "马来语", "name": "Bahasa Melayu", "local": "ms", },
    { "label": "塞尔维亚语", "name": "Српски", "local": "sr" ,antLocal:"sr_RS"   },
    { "label": "蒙古语", "name": "Монгол", "local": "mn" },
]
//简体中文,繁体中文,英文,西班牙语,韩语,日语,俄语,越南语,法语,德语,意大利语,荷兰语,阿拉伯语,印尼语,哈萨克语,波兰语,葡萄牙语,泰语,乌克兰语,希腊语,土耳其语,印地语,阿尔巴尼亚语,马来语,塞尔维亚语
const _defaultLang = initLange();

let _currentLocal = _defaultLang?.i18n;

export function initLange() {
    console.log('initLange');
    let lang;
    let langV2 = null    
    const storeLocal = window.localStorage.getItem('system-local');
    if (!storeLocal) {
        const type = navigator.appName;
        const defaultLocal = 'en'; // 如果未获取到，默认语言为英文

        if (type === 'Netscape') {
            lang = navigator.language.toLowerCase(); // 获取浏览器配置语言，支持非IE浏览器
        } else {
            lang = navigator.userLanguage.toLowerCase(); // 获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
        }

        if (!lang) return defaultLocal;

        lang = lang.replace('_', '-');

        if (lang.startsWith('zh-')&&lang.endsWith('-cn')) {
            lang = 'zh';
        }else if(lang.startsWith('zh-')){
            lang = 'zh-TW';
        }
        const langAbbreviate = lang.split('-')[0];
        langV2 = langAbbreviate==='zh'?lang:langAbbreviate;
        window.localStorage.setItem('system-local', langV2);
    }else{
        lang = storeLocal.toLowerCase().replace('_', '-');

        if (lang.startsWith('zh-')&&lang.endsWith('-cn')) {
            lang = 'zh';
        }else if(lang.startsWith('zh-')){
            lang = 'zh-TW';
        }
        const langAbbreviate = lang.split('-')[0];
        langV2 = langAbbreviate==='zh'?lang:langAbbreviate;
        if(storeLocal !== langV2){
            window.localStorage.setItem('system-local', langV2); 
        }
    }
    
    const findItem = i18nLanguages.map(item=>{
        try {
            const langModule = require(`./${item.local}`);
            return {
                ...item,
                i18n: langModule.default || langModule
            }
        } catch (error) {
            console.warn(`Language file for ${item.local} not found:`, error);
            return {
                ...item,
                i18n: {}
            }
        }
    }).find(item => item.local === langV2)||{
        name: '语言',
        label: '简体中文',
        local: 'zh',
        i18n: zh,
    };
    return findItem;
}
/**
 * 设置当前语言集
 * @param current
 */
export function setCurrentLocal(current) {
    _currentLocal = current;
}

/**
 * 获取当前语言集
 */
export function getCurrentLocal() {
    return _currentLocal;
}
/**
 * 获取当前语言集对象
 */
export function getCurrentLocalObj() {
    const local = window.localStorage.getItem('system-local');
    const findItem = newLanges().find(item => item.local === local)
    return findItem ? findItem : _defaultLang;
}
/**
 * 系统默认语言
 * @type {{name: string, label: string, local: string, i18n: {application, ajaxTip, menu, login, setting}}}
 */
export const defaultLang = _defaultLang;


// export default i18nLanguages;
const newLanges = ()=>{
    return i18nLanguages.map(item=>{
        try {
            const langModule = require(`./${item.local}`);
            // console.log(langModule.default || langModule)
            // const langModule = import(`./${item.local}`);
            return {
                ...item,
                i18n: langModule.default || langModule
            }
        } catch (error) {
            console.warn(`Language file for ${item.local} not found:`, error);
            return {
                ...item,
                i18n: {}
            }
        }
    })
}
export default newLanges();
